import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface MapWindow {
  latitudeDelta: number;
  longitudeDelta: number;
}
export interface BusinessListState {
  mobileMapWindow: MapWindow;
}

const initialState: BusinessListState = {
  mobileMapWindow: {
    latitudeDelta: 0.1,
    longitudeDelta: 0.1,
  },
};

const mapSlice = createSlice({
  name: 'map',
  initialState,
  reducers: {
    setMobileMapWindow: (state, action: PayloadAction<MapWindow>) => {
      state.mobileMapWindow = action.payload;
    },
  },
});

export const { setMobileMapWindow } = mapSlice.actions;

export default mapSlice.reducer;
